import React from "react";
import AuthPage from "@/components/ui/AuthPage";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { connect } from "react-redux";
import useStyles from './DeleteAccountCardStyles';
import {
    Container,
} from '@mui/material';
import useHistory from "../../lib/hooks/useHistory";

interface Props {
    settings: any,
}

const DeleteAccountCard: React.FC<Props> = props => {

    const styles = useStyles()
    const history = useHistory();

    const {
        settings,
    } = props;

    const navigateHome = () => {
        let path = '/home';
        history.push(path);
    }

    return (
        <AuthPage
            title="We are sad to see you go!"
            icon={<MdOutlineMarkEmailRead />}
            actions={<button type="button" className="pb-btn pb-btn-outline" onClick={navigateHome}>Return to Home</button>}>
            <p>Please check your email and confirm your request to delete your account.</p>
            <p>If you do not receive an email within a few minutes, please check your <strong>spam folder</strong>.</p>
        </AuthPage>
    )

}

const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
});

export default connect(mapStateToProps)(DeleteAccountCard);
